import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import NavBar from './navBar';
import { useNavigate } from 'react-router-dom';
import EMPTY_CART_IMAGE from '../images/cart/cartEmpty.png';
import Pickle1 from '../images/cart/pickle-1.webp';
import Pickle2 from '../images/cart/pickle-2.png';
import Pickle3 from '../images/cart/pickle-3.jpeg';
import Spices1 from '../images/cart/spices-1.webp';
import Spices2 from '../images/cart/spices-2.jpg';
import Spices3 from '../images/cart/spices-3.jpeg';


const cartData = [
  {
    id: 2,
    name: "Chicken Pickle",
    image: "/static/media/ChickenPickle.e2109aad73fbae265622.png",
    rating: "4.8 | 184 Reviews",
    tags: ["Spicy", "Non-veg", "Mustard Oil"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  },
  {
    id: 1,
    name: "Amla Pickle",
    image: "/static/media/AmlaPickle.9ae4407316da1e4c0a89.png",
    rating: "4.7 | 279 Reviews",
    tags: ["Sweet & Tangy", "Oil Free", "Pure-veg"],
    prices: ["Rs 299 (MRP 400)", "Rs 499 (MRP 600)"]
  }
];

const Container = styled.div`
  position: relative;
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  z-index: 2;
`;


const Title = styled.h2`
  text-align: center;
  font-size: 30px;
  margin-bottom: 30px;
  color: #333;
`;

const ProductRow = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 100px 1fr 150px 120px;
  gap: 16px;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #eee;

  &:hover .remove-btn {
    opacity: 1;
    pointer-events: auto;
  }
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 12px;
  object-fit: contain;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Name = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

const Tags = styled.div`
  display: flex;
  gap: 8px;
  font-size: 13px;
  flex-wrap: wrap;

  span {
    background: #f1f1f1;
    padding: 4px 8px;
    border-radius: 8px;
    color: #555;
  }
`;

const Select = styled.select`
  padding: 6px 8px;
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: fit-content;
  max-width: 180px;
`;

const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    background: #ed8936;
    color: white;
    border: none;
    padding: 6px 12px;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background: #dd6b20;
    }
  }

  span {
    font-size: 16px;
    width: 24px;
    text-align: center;
  }
`;

const LineTotal = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

const TotalSection = styled.div`
  text-align: right;
  font-size: 22px;
  font-weight: bold;
  margin-top: 20px;
`;


const RemoveButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: rgba(218, 218, 218, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease, background 0.2s ease;

  &:hover {
    background:rgb(145, 143, 143);
  }
`;

const CheckoutButton = styled.button`
  display: block;
  margin: 30px auto 50px;
  padding: 12px 30px;
  background-color: #ed8936;
  color: white;
  font-size: 18px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.3s ease;

  &:hover {
    background-color: #dd6b20;
  }
`;


const EmptyContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

const EmptyImage = styled.img`
  max-width: 250px;
  margin-bottom: 20px;
`;

const EmptyText = styled.h3`
  color: #555;
  font-size: 32px;
  font-weight: 800;
`;


const BackgroundWrapper = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;

  .bg-food {
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
    width: 200px;
    height: 200px;
    opacity: 0.25;
    z-index: 0;
    pointer-events: none;
  }
`;




const parsePrice = (priceStr) => {
  const match = priceStr.match(/Rs\s(\d+)/);
  return match ? parseInt(match[1]) : 0;
};

const CartPage = () => {
  const navigate = useNavigate();

  const [cart, setCart] = useState(
    cartData.map(item => ({
      ...item,
      selectedPriceIndex: 0,
      quantity: 1
    }))
  );

  // useEffect(() => {
  //   if (cart && cart.length > 0) {
  //     const updatedCart = cart.map(item => ({
  //       ...item,
  //       selectedPriceIndex: 0,
  //       quantity: 1
  //     }));
  //     setCart(updatedCart);
  //   }
  // }, [cart, setCart]);

  const handleQuantityChange = (id, delta) => {
    setCart(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item
      )
    );
  };

  const handlePriceChange = (id, index) => {
    setCart(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, selectedPriceIndex: parseInt(index) }
          : item
      )
    );
  };

  const handleRemoveItem = (id) => {
    setCart(prev => prev.filter(item => item.id !== id));
  };

  const totalAmount = cart.reduce((total, item) => {
    const unitPrice = parsePrice(item.prices[item.selectedPriceIndex]);
    return total + unitPrice * item.quantity;
  }, 0);

  return (
    <BackgroundWrapper>
    <NavBar/>
     <div
      className="bg-food"
      style={{
        top: '15%',
        left: '5%',
        backgroundImage: `url(${Pickle1})`
      }}
    />
    <div
      className="bg-food"
      style={{
        top: '75%',
        left: '75%',
        backgroundImage: `url(${Spices1})`
      }}
    />
    <div
      className="bg-food"
      style={{
        top: '50%',
        left: '3%',
        backgroundImage: `url(${Pickle2})`
      }}
    />
    <div
      className="bg-food"
      style={{
        top: '73%',
        left: '20%',
        backgroundImage: `url(${Spices2})`
      }}
    />
    <div
      className="bg-food"
      style={{
        top: '15%',
        left: '80%',
        backgroundImage: `url(${Pickle3})`
      }}
    />
    <div
      className="bg-food"
      style={{
        top: '45%',
        left: '85%',
        backgroundImage: `url(${Spices3})`
      }}
    />
    {cart.length === 0 ? (
        <EmptyContainer>
          <EmptyImage src={EMPTY_CART_IMAGE} alt="Empty Cart" />
          <EmptyText>Your cart is empty</EmptyText>
        </EmptyContainer>
      ) : (
        <>
          <Container>
            <Title>Your Cart</Title>
            {cart.map(item => {
              const unitPrice = parsePrice(item.prices[item.selectedPriceIndex]);
              const lineTotal = unitPrice * item.quantity;

              return (
                <ProductRow key={item.id}>
                  <RemoveButton className="remove-btn" onClick={() => handleRemoveItem(item.id)}>
                    ✕
                  </RemoveButton>
                  <Image src={item.image} alt={item.name} />
                  <Info>
                    <Name>{item.name}</Name>
                    <Tags>
                      {item.tags.map((tag, idx) => (
                        <span key={idx}>{tag}</span>
                      ))}
                    </Tags>
                    <Select
                      value={item.selectedPriceIndex}
                      onChange={(e) => handlePriceChange(item.id, e.target.value)}
                    >
                      {item.prices.map((price, i) => (
                        <option value={i} key={i}>
                          {price}
                        </option>
                      ))}
                    </Select>
                  </Info>
                  <QuantityControl>
                    <button onClick={() => handleQuantityChange(item.id, -1)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => handleQuantityChange(item.id, 1)}>+</button>
                  </QuantityControl>
                  <LineTotal>₹{lineTotal}</LineTotal>
                </ProductRow>
              );
            })}
            <TotalSection>Total: ₹{totalAmount}</TotalSection>
          </Container>
          <CheckoutButton onClick={() => navigate('/cardPayment', { state: { totalAmount } })}>
            Proceed to Checkout
          </CheckoutButton>
        </>
      )}
    
    </BackgroundWrapper>
    
  );
};

export default CartPage;